<template>
    <div class="link-doc">
        <div class="link-doc-item" v-if="!!lvProps&&lvProps.length>0">
            <h2 class="link-doc-item-head" v-if="!noTitle">Props</h2>
            <table>
                <thead>
                <tr>
                    <th>参数</th>
                    <th>类型</th>
                    <th>可选值</th>
                    <th>默认值</th>
                    <th>说明</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in lvProps" :key="index">
                    <td>{{item.name || '---'}}{{item.required?'（必输）':null}}</td>
                    <td>{{item.type || '---'}}</td>
                    <td>{{item.type === 'Boolean'?'true|false':item.select || '---'}}</td>
                    <td>{{item.type === 'Boolean'&&item.default == null?'false':item.default || '---'}}</td>
                    <td>{{item.desc || '---'}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="link-doc-item" v-if="!!lvEvents&&lvEvents.length>0">
            <h2 class="link-doc-item-head" v-if="!noTitle">Events</h2>
            <table>
                <thead>
                <tr>
                    <th>事件名</th>
                    <th>说明</th>
                    <th>参数</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in lvEvents" :key="index">
                    <td>{{item.name || '---'}}</td>
                    <td>{{item.desc || '---'}}</td>
                    <td>{{item.param || '---'}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="link-doc-item" v-if="!!lvMethods&&lvMethods.length>0">
            <h2 class="link-doc-item-head" v-if="!noTitle">Methods</h2>
            <table>
                <thead>
                <tr>
                    <th>方法名</th>
                    <th>说明</th>
                    <th width="20%">参数</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in lvMethods" :key="index">
                    <td>{{item.name || '---'}}</td>
                    <td>{{item.desc || '---'}}</td>
                    <td>{{item.param || '---'}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="link-doc-item" v-if="!!lvSlots&&lvSlots.length>0">
            <h2 class="link-doc-item-head" v-if="!noTitle">Slots</h2>
            <table>
                <thead>
                <tr>
                    <th>插槽名称</th>
                    <th>说明</th>
                    <th>作用域参数</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in lvSlots" :key="index">
                    <td>{{item.name || '---'}}</td>
                    <td>{{item.desc || '---'}}</td>
                    <td>{{item.param || '---'}}</td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "link-doc",
        props: {
            lvProps: {type: Array},
            lvEvents: {type: Array},
            lvMethods: {type: Array},
            lvSlots: {type: Array},
            noTitle: {type: Boolean},
        },
    }
</script>

<style lang="scss">
    @include themeify{
        .link-doc {
            padding: 0 20px;
            .link-doc-item {
                .link-doc-item-head {
                    color: $color-primary;
                }
                table {
                    width: 100%;
                    border-spacing: 0;
                    border-collapse: collapse;
                    thead {
                        font-size: 12px;
                        color: $color-normal-title;
                        background-color: $auto-table-head-background-color;
                    }
                    thead, tbody {
                        tr th, tr td {
                            text-align: left;
                            height: 28px;
                            border: solid #f2f2f2 1px;
                            padding: 0 12px !important;
                            letter-spacing: 0.5px;
                        }
                        tr td {
                            font-size: 12px;
                            padding: 6px 0;
                        }
                    }
                    thead {
                        th:not(:last-child) {
                            width: 150px;
                        }
                    }
                }

            }
        }

    }
</style>
